module.exports = __webpack_public_path__ + "img/revenues.5c1d7667.svg";